import styles from './CmsCard.module.scss';
import SliderCard from '@components/components/CmsComponents/components/CmsCard/components/SliderCard/SliderCard';
import ImageCard from '@components/components/CmsComponents/components/CmsCard/components/ImageCard/ImageCard';
import { trackInteraction } from '@components/hooks';
import { getBlockTitle } from '@components/utils';
import React from 'react';
import { ChoiceCard, IconCard, Link } from '@wienenergiegithub/ui-next';
import classNames from 'classnames';
import PropTypes from 'prop-types';

const CmsCard = ({
  mainTitle,
  type,
  as: Tag = 'div',
  headingLevel = 3,
  inSlider = false,
  className,
  interactionId,
  containerDimension,
  isFlexItem = false,
  ...card
}) => {
  const handleClick = () => {
    if (interactionId) {
      trackInteraction(interactionId);
    }
  };
  const componentName = getBlockTitle(
    'acf/cardlist',
    null,
    `${mainTitle}/${card?.title}`,
  );

  const renderElement = () => {
    switch (type) {
      case 'textSlidingCard':
      case 'iconSlidingCard':
        return (
          <SliderCard
            {...card}
            as={card?.action ? Link : 'div'}
            className={className}
            headingLevel={headingLevel}
            inSlider={inSlider}
            onClick={handleClick}
            type={type}
          />
        );
      case 'helpCard':
      case 'infoCard':
        return (
          <IconCard
            {...card}
            as={card?.action ? Link : 'div'}
            className={className}
            contentSize={type === 'infoCard' ? 'md' : 'regular'}
            glyph={card?.icon?.src ? null : card.icon}
            hasAction={!!card?.action?.url}
            headingLevel={headingLevel}
            icon={card?.icon?.src}
            onClick={handleClick}
            theme={type === 'infoCard' ? 'highlight' : 'default'}
            to={card?.action?.url}
            type={type}
            variant="iconTop"
          />
        );
      case 'contentCard':
      case 'imageCard':
        return (
          <ImageCard
            {...card}
            as={card?.action ? Link : 'div'}
            className={className}
            headingLevel={headingLevel}
            onClick={handleClick}
            type={type}
          />
        );
      case 'choiceCard':
        return (
          <ChoiceCard
            as={card?.action ? Link : 'div'}
            glyph={!card?.icon?.src && card.icon}
            headingLevel={headingLevel}
            image={card?.icon?.src && card.icon}
            linkTitle={card?.action?.title}
            title={card?.title}
            to={card?.action?.url}
            type={type}
          />
        );
      default:
        return null;
    }
  };

  return (
    <Tag
      className={classNames(styles.listItem, {
        [styles.additionalPaddingBottom]: card?.action && type === 'helpCard',
        [styles.flexItem]: isFlexItem,
        [styles.isInLargeContainer]: isFlexItem && containerDimension === 'lg',
        [styles.isInMediumContainer]: isFlexItem && containerDimension === 'md',
      })}
      data-componentname={componentName}
      data-purpose="acf/cardlist"
    >
      {renderElement()}
    </Tag>
  );
};

CmsCard.propTypes = {
  as: PropTypes.oneOfType([PropTypes.string, PropTypes.elementType]),
  className: PropTypes.string,
  headingLevel: PropTypes.number,
  inSlider: PropTypes.bool,
  interactionId: PropTypes.string,
  isFlexItem: PropTypes.bool,
  mainTitle: PropTypes.string,
  type: PropTypes.oneOf([
    'textSlidingCard',
    'iconSlidingCard',
    'helpCard',
    'infoCard',
    'contentCard',
    'imageCard',
    'choiceCard',
  ]).isRequired,
};

export default CmsCard;
